import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_have_occupational_safety_health_osh_committee'

export const dataPointDefinition = {
  retracedId: 'does_facility_have_occupational_safety_health_osh_committee',
  name: 'Does the facility have an occupational safety and health (OSH) committee that is formed and functioning in line with leg',
  description:
    'An OSH committee is a group made up of representatives of workers and facility management to discuss work-related safety and health.',
  meta: {
    slcpMeta: {
      key: 'hs-hsc-1',
      number: 'HS-HSC-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-hsc-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31320,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
